import { resolveComponent as _resolveComponent, createVNode as _createVNode, createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, vModelText as _vModelText, withDirectives as _withDirectives, normalizeClass as _normalizeClass, withCtx as _withCtx, toDisplayString as _toDisplayString, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, vShow as _vShow, withModifiers as _withModifiers, createElementBlock as _createElementBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue";
const _withScopeId = n => (_pushScopeId("data-v-4662cd90"), n = n(), _popScopeId(), n);
const _hoisted_1 = {
  class: "main-page"
};
const _hoisted_2 = {
  class: "video-desc"
};
const _hoisted_3 = {
  class: "push-content"
};
const _hoisted_4 = {
  class: "flex push-li items-center"
};
const _hoisted_5 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("span", null, [/*#__PURE__*/_createElementVNode("i", null, "*"), /*#__PURE__*/_createTextVNode("小程序appid ")], -1));
const _hoisted_6 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("p", {
  class: "input-line"
}, null, -1));
const _hoisted_7 = {
  class: "flex push-li items-center"
};
const _hoisted_8 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("span", null, [/*#__PURE__*/_createElementVNode("i", null, "*"), /*#__PURE__*/_createTextVNode("推广链接名称")], -1));
const _hoisted_9 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("p", {
  class: "input-line"
}, null, -1));
const _hoisted_10 = {
  class: "flex push-li items-center"
};
const _hoisted_11 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("span", null, [/*#__PURE__*/_createElementVNode("i", null, "*"), /*#__PURE__*/_createTextVNode("推广链接")], -1));
const _hoisted_12 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("p", {
  class: "input-line"
}, null, -1));
const _hoisted_13 = {
  class: "push-content"
};
const _hoisted_14 = {
  class: "flex push-li items-center"
};
const _hoisted_15 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("span", null, [/*#__PURE__*/_createElementVNode("i", null, "*"), /*#__PURE__*/_createTextVNode("计划名称")], -1));
const _hoisted_16 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("p", {
  class: "input-line"
}, null, -1));
const _hoisted_17 = {
  class: "flex push-li items-center"
};
const _hoisted_18 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("span", null, [/*#__PURE__*/_createElementVNode("i", null, "*"), /*#__PURE__*/_createTextVNode("推广集数")], -1));
const _hoisted_19 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("p", {
  class: "input-line"
}, null, -1));
const _hoisted_20 = {
  key: 0,
  class: "share-h5-box flex-column"
};
const _hoisted_21 = {
  style: {
    "height": "50px",
    "padding": "0 20px 20px"
  }
};
const _hoisted_22 = {
  class: "share-txt"
};
const _hoisted_23 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("div", {
  id: "ossfile"
}, null, -1));
const _hoisted_24 = {
  id: "container",
  class: "flex-column flex-justify-between"
};
const _hoisted_25 = {
  class: "share-btn",
  id: "selectfiles",
  href: "javascript:void(0);"
};
const _hoisted_26 = {
  class: "flex-column flex-justify-between",
  style: {
    "z-index": "99"
  }
};
export function render(_ctx, _cache, $props, $setup, $data, $options) {
  const _component_ttNavHeader = _resolveComponent("ttNavHeader");
  const _component_van_action_sheet = _resolveComponent("van-action-sheet");
  const _component_van_progress = _resolveComponent("van-progress");
  const _component_van_icon = _resolveComponent("van-icon");
  const _component_van_overlay = _resolveComponent("van-overlay");
  return _openBlock(), _createElementBlock("div", _hoisted_1, [_createVNode(_component_ttNavHeader, {
    title: "内容详情"
  }), _createElementVNode("div", {
    class: _normalizeClass(["content-page", {
      'app-active': $setup.isapp
    }])
  }, [_createElementVNode("div", _hoisted_2, [_createElementVNode("div", _hoisted_3, [_createElementVNode("ul", null, [_createElementVNode("li", _hoisted_4, [_hoisted_5, _createElementVNode("div", null, [_withDirectives(_createElementVNode("input", {
    type: "text",
    "onUpdate:modelValue": _cache[0] || (_cache[0] = $event => $setup.appid = $event),
    placeholder: "小程序appid "
  }, null, 512), [[_vModelText, $setup.appid]]), _hoisted_6])]), _createElementVNode("li", _hoisted_7, [_hoisted_8, _createElementVNode("div", null, [_withDirectives(_createElementVNode("input", {
    type: "text",
    "onUpdate:modelValue": _cache[1] || (_cache[1] = $event => $setup.tname = $event),
    placeholder: "推广链接名称"
  }, null, 512), [[_vModelText, $setup.tname]]), _hoisted_9])]), _createElementVNode("li", _hoisted_10, [_hoisted_11, _createElementVNode("div", null, [_withDirectives(_createElementVNode("input", {
    type: "text",
    "onUpdate:modelValue": _cache[2] || (_cache[2] = $event => $setup.path = $event),
    placeholder: "推广链接"
  }, null, 512), [[_vModelText, $setup.path]]), _hoisted_12])])]), _createElementVNode("span", {
    class: "push-confrim-btn",
    onClick: _cache[3] || (_cache[3] = function () {
      return $setup.confirmAction && $setup.confirmAction(...arguments);
    })
  }, "挂载")])])], 2), _createVNode(_component_van_action_sheet, {
    show: $setup.isShow,
    "onUpdate:show": _cache[7] || (_cache[7] = $event => $setup.isShow = $event),
    title: "创建推广"
  }, {
    default: _withCtx(() => [_createElementVNode("div", _hoisted_13, [_createElementVNode("ul", null, [_createElementVNode("li", _hoisted_14, [_hoisted_15, _createElementVNode("div", null, [_withDirectives(_createElementVNode("input", {
      type: "text",
      "onUpdate:modelValue": _cache[4] || (_cache[4] = $event => $setup.name = $event),
      placeholder: "请输入计划名称(字数15个字以内)"
    }, null, 512), [[_vModelText, $setup.name]]), _hoisted_16])]), _createElementVNode("li", _hoisted_17, [_hoisted_18, _createElementVNode("div", null, [_withDirectives(_createElementVNode("input", {
      type: "number",
      "onUpdate:modelValue": _cache[5] || (_cache[5] = $event => $setup.chapterIdx = $event),
      max: "10",
      placeholder: "推广剧集序号,例如1、2..."
    }, null, 512), [[_vModelText, $setup.chapterIdx]]), _hoisted_19])])]), _createElementVNode("span", {
      class: "push-confrim-btn",
      onClick: _cache[6] || (_cache[6] = function () {
        return $setup.confirm && $setup.confirm(...arguments);
      })
    }, "提交")])]),
    _: 1
  }, 8, ["show"]), _createVNode(_component_van_overlay, {
    show: $setup.upshow,
    "z-index": "99"
  }, {
    default: _withCtx(() => [$setup.upshow ? (_openBlock(), _createElementBlock("div", _hoisted_20, [_createElementVNode("div", _hoisted_21, [_createElementVNode("p", _hoisted_22, _toDisplayString($setup.dyShareMsg || '请选择上传文件'), 1), _hoisted_23, _ctx.percentage > 0 ? (_openBlock(), _createBlock(_component_van_progress, {
      key: 0,
      color: "#FF3333",
      strokeWidth: 8,
      showPivot: false,
      percentage: _ctx.percentage
    }, null, 8, ["percentage"])) : _createCommentVNode("", true)]), _createElementVNode("div", _hoisted_24, [_withDirectives(_createElementVNode("p", _hoisted_25, "选择文件", 512), [[_vShow, $setup.isFile]])]), _createElementVNode("div", _hoisted_26, [_createElementVNode("p", {
      class: _normalizeClass(["share-btn", {
        'share-success': $setup.dyShareOver,
        'share-loading': !$setup.dyShareOver
      }]),
      onClick: _cache[8] || (_cache[8] = _withModifiers(function () {
        return _ctx.closeFilePop && _ctx.closeFilePop(...arguments);
      }, ["stop"]))
    }, _toDisplayString($setup.dyShareMsg.indexOf('失败') > -1 ? '关闭' : '立即挂载'), 3)]), $setup.isFile ? (_openBlock(), _createElementBlock("span", {
      key: 0,
      class: "close",
      onClick: _cache[9] || (_cache[9] = $event => _ctx.closeFilePop('close'))
    }, [_createVNode(_component_van_icon, {
      name: "close",
      color: "#fff",
      size: "20"
    })])) : _createCommentVNode("", true)])) : _createCommentVNode("", true)]),
    _: 1
  }, 8, ["show"]), _createVNode(_component_van_action_sheet, {
    show: $setup.sheetShow,
    "onUpdate:show": _cache[10] || (_cache[10] = $event => $setup.sheetShow = $event),
    actions: [{
      name: '快手',
      value: 'kwai'
    }, {
      name: '快手极速版',
      value: 'ksnebula'
    }],
    "cancel-text": "取消",
    description: "请选择要挂载的快手",
    "close-on-click-action": "",
    onSelect: $setup.selectSheet,
    onCancel: _cache[11] || (_cache[11] = $event => $setup.sheetShow = false)
  }, null, 8, ["show", "onSelect"])]);
}